import React, {Component} from 'react';
import {Button, Cascader, Col, DatePicker, Form, Icon, Input, Modal, Radio, Row, Select, Upload} from "antd";
import config from "../../config";
import {api, app} from "../../app";
import moment from "moment";
import PayTemplate from "../../components/PayTemplate";

const Option = Select.Option
const FormItem = Form.Item
const RadioGroup = Radio.Group

function beforeUpload (file) {
    let format = ['image/jpeg', 'image/jpg', 'image/png'];
    const is = format.indexOf(file.type) > -1;
    if (!is) {
        app.alert('仅可上传文件类型为: ' + format.join("、"), 'warn');
        return Promise.reject();
    }
    return Promise.resolve();
}

class ApplyClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            region_id:'',
            subject_id:'',
            up_loading:false,
            regionsList:[],
            cityList:[],
            classData:[],
            is_submit:0,
            update_loading:false,
            pay_method:'',
            courseList:[],
            trainName:'',
            guidance_url:''
        }
    }

    async componentDidMount() {
        this._isMounted = true;
        await this.regionsData()
        await this.regionsData(2)
        await this.courseData()
        await this.guidance()
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    /**
     * 图片上传变更
     * @param info
     */
    handleImgUploadChage = ({ file }) => {
        if (file.status === 'uploading') {
            this.setData({ up_loading: true });
            return;
        }
        if (file.status === 'done' && file.response && file.response.flag === 1) {
            this.setData({ up_img: file.response.data.url, up_loading: false });
        }
    };
    /**
     * 获取城市信息
     */
    onChangeCity = async (value,obj) => {
        let arr = ['110000','120000','310000','500000'],
            name = ''
        for (let i=0;i<obj.length;i++){
            name += obj[i].region_name
            if(arr.includes(obj[i].region_id)){
                break
            }
        }
        this.props.form.setFieldsValue({ train_name: name + '应急救援培训班' })
        //await this.setData({ trainName: name + '应急救援培训班' })
    }

    /**
     * 选择科目
     */
    onChange = async (value) => {
        let {courseList} = this.state;
        courseList.map(async (item) => {
           if(item.id == value){
               await this.setData({ classData: item })
           }
        })
    }

    /**
     * 获取地区信息
     */
    onChangeRegions = async (value) => {
        console.log(value)
    }

    /**
     * 勾选须知
     */
    onChangeRadio = async (e) => {
        await this.setData({ is_submit: e.target.value })
    }

    /**
     * 支付方式
     */
    onChangePay = async (e) => {
        await this.setData({ pay_method: e.target.value })
    }

    /**
     * 地区数据
     **/
    regionsData = async (level) => {
        await this.setData({ regions_loading: true })
        let params = {type:level};
        let { flag, data, msg } = await app.post(api.SkillTrainRegions,params?params:'')
        let state = { regions_loading: false },
        arr = ['710000','810000','820000']
        if (flag === 1) {
            data.map((item,index) => {
                if(arr.includes(item.region_id)){
                    if(!data[index].disabled){
                        data[index].disabled = true
                    }
                }
            })
            if(level ==2){
                state.cityList = data
            }else{
                state.regionsList = data
            }
        } else {
            app.alert(msg, "error")
        }
        await this.setData(state)
    }

    /**
     * 报名须知
     **/
    guidance = async () => {
        await this.setData({ guidance_loading: true })
        let { flag, data, msg } = await app.post(api.SkillTrainGuidance)
        let state = { guidance_loading: false }
        if (flag === 1) {
            state.guidance_url = data.url
        } else {
            app.alert(msg, "error")
        }
        await this.setData(state)
    }

    /**
     * 课程数据
     **/
    courseData = async () => {
        await this.setData({ course_loading: true })
        let { flag, data, msg } = await app.post(api.SkillTrainCourselist)
        let state = { course_loading: false }
        if (flag === 1) {
                state.courseList = data
        } else {
            app.alert(msg, "error")
        }
        await this.setData(state)
    }

    /**
     * 提交
     **/
    handleAdd = (e) => {
        e.preventDefault()
        this.props.form.validateFieldsAndScroll(async (err, values) => {
            if (err) {
                return;
            }
            const {up_img, update_loading, is_submit, pay_method} = this.state,
                params = {
                    apply_province_id: values.region_id[0],
                    apply_city_id: values.region_id[1],
                    train_name: values.train_name,
                    ppeclass_id:values.ppeclass_id,
                    images: up_img,
                    name: values.name,
                    idno: values.idno,
                    sex: values.sex,
                    mobile: values.mobile,
                    birthdate: moment(values.birthdate).format("YYYY-MM-DD"),
                    mail_province: values.mail_region[0],
                    mail_city: values.mail_region[1],
                    mail_district: values.mail_region[2],
                    mail_address: values.mail_address,
                    pay_method:pay_method
                }
            if (update_loading) return false
            if (!up_img) {
                app.alert("请上传您的头像照片", 'error')
                return
            }
            if(!params.mail_province){
                app.alert("请选择证书邮寄的省份", 'error')
                return
            }else if(!params.mail_city){
                app.alert("请选择证书邮寄的城市", 'error')
                return
            }else if(!params.mail_district){
                app.alert("请选择证书邮寄的地区", 'error')
                return
            }
            if(!pay_method){
                app.alert("请选择付款方式", 'error')
                return
            }
            if (is_submit != 1) {
                app.alert("请勾选我已阅读《报名须知》", 'error')
                return
            }

            await this.setData({update_loading: true})
            const { flag, data, msg } = await app.post(api.SkillTrainApplyTrain, params)
            app.alertDestroy()
            if (flag === 1) {
                Modal.confirm({
                    title: '扫码支付',
                    centered: true,
                    icon: pay_method==2?(<Icon type="alipay-circle" style={{ color: '#00A1E9' }} />):(<Icon type="wechat" style={{color: '#00D30C'}}/>),
                    width: 600,
                    content: pay_method==2?(<PayTemplate qrcode={data.qrUrl} money={data.totalAmount} />):(<PayTemplate qrcode={data.qrUrl} money={data.totalAmount} terminal="微信" />),
                    okText: '已支付',
                    cancelText: '关闭',
                    onOk: async () => {
                        const { flag, msg } = await app.post(api.SkillTrainConfirmPay, {
                            orders_no: data.ordersNo
                        })
                        if (flag === 1) {
                            app.alert('支付成功', 'success')
                            this.props.history.push({
                                pathname: '/skillTrain/mtList',
                                state: {
                                    name:values.name,
                                    idno:values.idno
                                }
                            })
                            return true
                        } else {
                            app.alert(msg, 'warn')
                            throw false
                        }
                    }
                })
            } else {
                app.alert(msg, 'warn')
            }
            await this.setData({ update_loading: false })
        })
    }

    filter = (inputValue, path) => {
        return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    }

    /**
     * 设置值
     * @param data
     */
    setData = (data) => app.setStateSync(this, data)

    render() {
        let {up_img,up_loading,regionsList,classData,is_submit,update_loading,cityList,courseList,guidance_url} = this.state
        let { form } = this.props,
            { getFieldDecorator } = form,
            formItemLayout = {
                labelAlign: 'left',
                labelCol: { span: 4, offset: 2 },
                wrapperCol: { span: 16},
            }
        return (
            <div className="su-nearby">
                <Form {...formItemLayout} onSubmit={this.handleAdd}>
                    <div className="train-info">
                        <div className="su-nearby-title">培训信息</div>
                        <div className="train-info-data back-padding">
                            <FormItem label="期望开班城市">
                                {getFieldDecorator('region_id', {
                                    rules: [{
                                        required: true, message: '请选择证期望开班城市!',
                                    }],
                                })(
                                    <Cascader
                                        onChange={this.onChangeCity}
                                        options={cityList}
                                        placeholder="选择城市"
                                        fieldNames={{ label: 'region_name', value: 'region_id', children: 'sublevel' }}
                                        notFoundContent="无记录"
                                        showSearch={this.filter}
                                    />
                                )}
                            </FormItem>
                            <FormItem label="培训课程">
                                {getFieldDecorator('train_name', {
                                    rules: [{ required: true, message: '请输入培训课程!' }],
                                })(
                                    <Input placeholder="请输入培训课程"/>
                                )}
                            </FormItem>
                            <FormItem label="培训科目" hasFeedback>
                                {getFieldDecorator('ppeclass_id', {
                                    rules: [{ required: true, message: '请选择培训科目!' }],
                                })(
                                    <Select
                                        showSearch
                                        placeholder="请选择培训科目"
                                        optionFilterProp="children"
                                        onChange={this.onChange}
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {
                                            courseList.map(b => {
                                                return (
                                                    <Option key={b.id} value={b.id}>{b.names}</Option>
                                                )
                                            })
                                        }
                                    </Select>
                                )}
                            </FormItem>
                            {classData.length != 0?
                            <div>
                                {/*<Row className="margin-bot">*/}
                                {/*    <Col className="font-left" span={15} offset={2}>招生人数（满60人即可开班）</Col>*/}
                                {/*    <Col className="font-right" span={5}>{classData.train_number}人</Col>*/}
                                {/*</Row>*/}
                                {/*<Row className="margin-bot">*/}
                                {/*    <Col className="font-left" span={15} offset={2}>已报名人数</Col>*/}
                                {/*    <Col className="font-right" span={5}>{classData.apply_number}人</Col>*/}
                                {/*</Row>*/}
                                <Row className="margin-bot">
                                    <Col className="font-left" span={15} offset={2}>培训天数</Col>
                                    <Col className="font-right" span={5}>{classData.train_day}天</Col>
                                </Row>
                                <Row className="margin-bot">
                                    <Col className="font-left" span={15} offset={2}>考评天数</Col>
                                    <Col className="font-right" span={5}>{classData.evaluate_day}天</Col>
                                </Row>
                                <Row className="margin-bot">
                                    <Col className="font-left" span={15} offset={2}>培训费用</Col>
                                    <Col className="font-right" span={5}>{classData.train_money}元</Col>
                                </Row>
                                <Row className="margin-bot">
                                    <Col className="font-left" span={15} offset={2}>考评费用</Col>
                                    <Col className="font-right" span={5}>{classData.evaluate_money}元</Col>
                                </Row>
                            </div>
                            :null}
                        </div>
                        {classData.length != 0?
                        <div>
                            <div className="su-nearby-title">个人信息</div>
                            <div className="info-data back-padding">
                                <Row type="flex" justify="center">
                                    <Col style={{ width: 110, textAlign: 'center' }}>
                                        <Upload action={config.serverUrl + api.ImageUpload}
                                                accept='image/jpeg, image/jpg, image/png'
                                                data={{
                                                    upload_type: 'ppe_train',
                                                }}
                                                name="image"
                                                onChange={this.handleImgUploadChage}
                                                beforeUpload={beforeUpload}
                                                listType="picture-card"
                                                showUploadList={false}
                                        >
                                            {up_img ?
                                                <img src={config.imgUrl + up_img} style={{ width: '100%' }} alt="头像" className="avatar"/> :
                                                (
                                                    <div>
                                                        <Icon type={up_loading ? 'loading' : 'plus'}/>
                                                        <div className="ant-upload-text">2寸免冠彩照</div>
                                                    </div>
                                                )}
                                        </Upload>
                                    </Col>
                                </Row>
                                <Row>
                                    <div style={{ textAlign: 'center', marginBottom:'25px'}}>头像用于制作技能证书</div>
                                </Row>
                                <FormItem label="姓名">
                                    {getFieldDecorator('name', {
                                        rules: [{ required: true, message: '请输入姓名!' }],
                                    })(
                                        <Input placeholder="请输入姓名"/>
                                    )}
                                </FormItem>
                                <FormItem label="身份证号码">
                                    {getFieldDecorator('idno', {
                                        rules: [{ required: true, message: '请输入身份证号码!' }],
                                    })(
                                        <Input placeholder="请输入身份证号码"/>
                                    )}
                                </FormItem>
                                <FormItem label="性别">
                                    {getFieldDecorator('sex', {
                                        rules: [{ required: true, message: '请选择性别！' }],
                                    })(
                                        <Select placeholder="请选择性别">
                                            <Option value="男">男</Option>
                                            <Option value="女">女</Option>
                                        </Select>,
                                    )}
                                </FormItem>
                                <FormItem label="手机号码">
                                    {getFieldDecorator('mobile', {
                                        rules: [{ required: true, message: '请输入手机号码!' }],
                                    })(
                                        <Input placeholder="请输入手机号码"/>
                                    )}
                                </FormItem>
                                <FormItem label="出生年月日">
                                    {getFieldDecorator('birthdate', {
                                        rules: [{ required: true, message: '请选择您的生日!' }]
                                    })(
                                        <DatePicker placeholder="请选择您的生日" />
                                    )}
                                </FormItem>
                            </div>
                            <div className="su-nearby-title">证书邮寄地址</div>
                            <div className="mailing-address back-padding">
                                <FormItem label="证书邮寄所属地区">
                                    {getFieldDecorator('mail_region', {
                                        rules: [{
                                            required: true, message: '请选择证书邮寄所属地区!',
                                        }],
                                    })(
                                        <Cascader
                                            options={regionsList}
                                            onChange={this.onChangeRegions}
                                            placeholder="选择城市"
                                            fieldNames={{ label: 'region_name', value: 'region_name', children: 'sublevel' }}
                                            notFoundContent="无记录"
                                            showSearch={this.filter}
                                        />
                                    )}
                                </FormItem>
                                <FormItem label="证书邮寄详细地址">
                                    {getFieldDecorator('mail_address', {
                                        rules: [{ required: true, message: '请输入证书邮寄详细地址!' }],
                                    })(
                                        <Input placeholder="请输入证书邮寄详细地址"/>
                                    )}
                                </FormItem>
                            </div>
                            <div className="su-nearby-title">培训费用</div>
                            <div className="train-cost back-padding">
                                <Row className="margin-bot">
                                    <Col className="font-left" span={15} offset={2}>培训总费用</Col>
                                    <Col className="font-right black bold" span={5}>{classData.train_amount}元</Col>
                                </Row>
                                <Row className="margin-bot">
                                    <Col className="font-left" span={15} offset={2}>预报名费（报名预交{classData.beforehand_money}元，可抵{classData.beforehand_money}元培训费）</Col>
                                    <Col className="font-right red bold" span={5}>{classData.beforehand_money}元</Col>
                                </Row>
                                <Row className="margin-bot">
                                    <Col className="font-left" span={15} offset={2}>支付方式</Col>
                                    <Col className="font-right" span={5}>在线支付</Col>
                                </Row>
                                <Row className="margin-bot">
                                    <Col className="font-left" span={10} offset={2}>付款方式</Col>
                                    <Col className="font-right" span={10}>
                                        <RadioGroup onChange={this.onChangePay}>
                                            <Radio value={1}>微信</Radio>
                                            <Radio className="pay-ali" style={{marginRight:'0'}} value={2}>支付宝</Radio>
                                        </RadioGroup>
                                    </Col>
                                </Row>
                            </div>
                            <div className="train-notice">
                                <Row type="flex" className="read-notice">
                                    <Col>
                                        <RadioGroup onChange={this.onChangeRadio} value={is_submit}>
                                            <Radio value={1}></Radio>
                                        </RadioGroup>
                                    </Col>
                                    <Col style={{lineHeight:'27px'}}><a href={config.imgUrl+guidance_url} target="_blank">我已详细阅读《报名须知》</a></Col>
                                </Row>
                                <Row>
                                    <span className="red bold">本次培训为自愿报名！</span>
                                    <span>每人报名时先预交报名费用，剩余费用开班前支付完成；报名人数满即可开班，班级人数不足开班需求人数的报名人员可申请转就近班培训</span>
                                </Row>
                                <Row type="flex" justify="center" className="info-submit">
                                    <Col span={6}>
                                        <Button size="large" type="primary" htmlType="submit" loading={update_loading} block>确认报名</Button>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                        :null}
                    </div>
                </Form>
            </div>
        );
    }
}
export default Form.create()(ApplyClass);



// WEBPACK FOOTER //
// ./src/routes/skillTrain/ApplyClass.jsx